module.exports = __webpack_public_path__ + "static/media/Ministre_de_lEnseignement_superieur.2c7a4c3f.svg";